/**
 * @file 任务模块配置
 */
const barConfig = [{
    prop:'allRegistryCount',
    num: 0,
    text: '注册总用户量'
},
{
    prop:'dayRegistryCount',
    num: 0,
    text: '今日注册人数'
},
// {
//     prop: 'tdvisit',
//     num: 0,
//     text: '今日访问人数'
// },
{
    prop: 'vipCount',
    num: 0,
    text: 'vip人数'
}];
export const menuIcon = {
    '/system': 'el-icon-s-tools',
    '/order': 'el-icon-s-custom',
    '/audit': 'el-icon-document',
    '/publish': 'el-icon-s-promotion'
}

export default {
    barConfig, menuIcon
};
